import { SignalType } from '@/types/devices'

export const SIGNAL_TYPE_COLORS: Record<SignalType, string> = {
  audio: '#FF6B6B',
  midi: '#4ECDC4',
  sync: '#45B7D1',
  cv_gate: '#FFA07A',
  adat: '#98D8C8',
  word_clock: '#F7DC6F',
  usb: '#BB8FCE',
  ethernet: '#85C1E2',
}

export const SIGNAL_TYPE_LABELS: Record<SignalType, string> = {
  audio: 'Audio',
  midi: 'MIDI',
  sync: 'Sync',
  cv_gate: 'CV/Gate',
  adat: 'ADAT',
  word_clock: 'Word Clock',
  usb: 'USB',
  ethernet: 'Ethernet',
}
